import "./App.css";
import Login from "./pages/login";
import { useEffect, useRef } from "react";
import { Box } from "@chakra-ui/react";
import { Navigate, Route, Routes, useNavigate, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Simulator from "./pages/simulator";
import Forgot from "./pages/forgot";
import SignUp from "./pages/signUp";
import ChangePassword from "./pages/changePassword";
import Dashboard from "./pages/dashboard";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
import Configurations from "./pages/Configurations";
import Tracking from "./pages/tracking";
import Processes from "./pages/processes";
import Documents from "./pages/documents";
import Process from "./pages/process";
import Report from "./pages/report";
import Account from "./pages/account";
import Financial from "./pages/financial";
import PurchaseOrders from "./pages/purchase-order";
import SavePurchaseOrder from "./pages/purchase-order/save";
import SaveProcess from "./pages/processes/save";
import PurchaseOrderPrint from "./pages/purchase-order/save/components/PurchaseOrderPrint";
import CRM from "./pages/crm";
import CrmDashboard from "./pages/crm/dashboard";
import Leads from "./pages/crm/leads";
import Tasks from "./pages/crm/tasks";
import Estimates from "./pages/crm/estimates";
import Prospects from "./pages/prospects";
import Backorder from "./pages/backorder";
import Commercial from "./pages/commercial";
import CommercialClients from "./pages/commercial/clients";
import CommercialSuppliers from "./pages/commercial/suppliers";
import Intranet from "./pages/intranet";
import CommercialSales from "./pages/commercial/sales";
import GestaoPainel from "./pages/gestao/painel";
import GestaoFunil from "./pages/gestao/funil";
import GestaoOperacoes from "./pages/gestao/operacoes";
import GestaoCambio from "./pages/gestao/cambio";
import GestaoSwifts from "./pages/gestao/swifts";
import GestaoComercial from "./pages/gestao/comercial";
import GestaoDistribuidora from "./pages/gestao/distribuidora";
import ScreenGuard from "./components/ScreenGuard";

function App() {
  const isAuth = useIsAuthenticated();
  const navigate = useNavigate();
  const location = useLocation();
  const unauthRoutes = ["login", "changepassword", "signup", "forgot"];
  const ref = useRef();
  useEffect(() => {
    if (
      !isAuth &&
      unauthRoutes.every((u) => !location.pathname.toLowerCase().includes(u))
    ) {
      navigate("/login");
    }
  }, []);
  return (
    <Box>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route
          path="/print"
          element={
            <PurchaseOrderPrint
              printRef={ref}
              purchaseOrder={{
                client: "asdasd",
                cnpj: "12345678901234",
                createdDate: "2000-01-01",
                poNumber: 1234,
                taxRegime: "Lucro Real",
                stOrDifalDestination: "ST ",
                invoiceRef: "fsadfsdaafsd",
                supplier:
                  "L & B INDUSTRIA E COMERCIO DE ARTIGOS DO VESTUARIO LTDA EPP",
                supplierInvoiceDate: "2000-01-01",
                originPort: "china",
                incoterm: "FOB",
                destinationPort: "brasil",
                productNcm: "12345",
                containerQty: "2cha",
                financialCost: 123.44,
                margin: "1",
                ownCash: true,
                nationalizationFactor: 2,
                finalInvoiceValue: 1234.45,
                totalFobValue: 32423.12,
                firstExchangeSupplierTerm: "(Na prontidão):",
                secondExchangeSupplierTerm: "(7 Dias Antes da Chegada):",
                nationalizationSupplierTerm: "(Desembaraço):",
                firstExchangeClientTerm: "(Na prontidão):",
                secondExchangeClientTerm: "(Contra NF):",
                nationalizationClientTerm: "(Contra NF):",
                firstExchangeSupplier: 1,
                secondExchangeSupplier: 2,
                nationalizationSupplier: 22,
                firstExchangeClient: 11,
                secondExchangeClient: 22,
                nationalizationClient: 22,
                firstExchangeDisbursement: 1,
                firstExchangeOpenTerm: 11,
                firstExchangeExpectedDate: "2025-01-12",
                secondExchangeDisbursement: 2,
                secondExchangeOpenTerm: 22,
                secondExchangeExpectedDate: "2025-12-31",
                clearanceDisbursement: 3,
                clearanceOpenTerm: 33,
                clearanceExpectedDate: "2025-02-12",
                invoiceValueDollar: 1.23,
                invoiceValueReal: 12.34,
                invoiceExpectedDate: "2024-02-12",
                exchangePaymentEntry: 12.34,
                exchangePaymentEntryDate: "2024-12-12",
                exchangePaymentEntryRate: 12.34,
                exchangePaymentBalance: 43.21,
                exchangePaymentBalanceDate: "2011-10-11",
                exchangePaymentBalanceRate: 3,
                clearanceTotal: 7.51,
                clearanceTotalDate: "2025-05-15",
                clearanceTotalRate: 4,
                freightAllIn: 12.34,
                freeTimeDays: 3,
                shipmentDate: "2023-03-13",
                arrivalDate: "2024-04-12",
                numeraryEntryDollar: 1,
                numeraryEntryDate: "2024-03-02",
                numeraryEntryReal: 1,
                numeraryBalanceDollar: 2,
                numeraryBalanceDate: "2024-03-30",
                numeraryBalanceReal: 4,
                numeraryClearanceDollar: 23,
                numeraryClearanceDate: "2022-12-12",
                numeraryClearanceReal: 5,
                numeraryComplementaryDollar: 44,
                numeraryComplementaryDate: "2007-05-04",
                numeraryComplementaryReal: 5,
                observations: "hs",
              }}
            />
          }
        ></Route>
        <Route path="/forgot" element={<Forgot />}></Route>
        <Route path="/signUp" element={<SignUp />}></Route>
        <Route path="/changePassword" element={<ChangePassword />}></Route>
        <Route
          path="/dashboard"
          element={
            <ScreenGuard link="/dashboard">
              <Dashboard />
            </ScreenGuard>
          }
        ></Route>
        <Route path="/configurations" element={<Configurations />}></Route>
        <Route path="/tracking" element={<Tracking />}></Route>
        <Route path="/account" element={<Account />}></Route>
        <Route
          path="/processes"
          element={
            <ScreenGuard link="/processes">
              <Processes />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/saveProcess"
          element={
            <ScreenGuard link="/processes">
              <SaveProcess />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/simulador"
          element={
            <ScreenGuard link="/simulador">
              <Simulator />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/process"
          element={
            <ScreenGuard link="/processes">
              <Process />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/documents"
          element={
            <ScreenGuard link="/documents">
              <Documents />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/financial"
          element={
            <ScreenGuard link="/financial">
              <Financial />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/purchaseOrders"
          element={
            <ScreenGuard link="/purchaseOrders">
              <PurchaseOrders />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/backorder"
          element={
            <ScreenGuard link="/backorder">
              <Backorder />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/prospects"
          element={
            <ScreenGuard link="/commercial/crm/leads">
              <Prospects />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/commercial"
          element={
            <ScreenGuard link="/commercial">
              <Commercial />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/commercial/clients"
          element={
            <ScreenGuard link="/commercial/clients">
              <CommercialClients />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/intranet"
          element={
            <ScreenGuard link="/intranet">
              <Intranet />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/commercial/suppliers"
          element={
            <ScreenGuard link="/commercial/suppliers">
              <CommercialSuppliers />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/commercial/sales"
          element={
            <ScreenGuard link="/commercial/sales">
              <CommercialSales />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/commercial/crm"
          element={
            <ScreenGuard link="/commercial/crm/leads">
              <CRM />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/commercial/crm/dashboard"
          element={
            <ScreenGuard link="/commercial/crm/dashboard">
              <CrmDashboard />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/commercial/crm/leads"
          element={
            <ScreenGuard link="/commercial/crm/leads">
              <Leads />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/commercial/crm/tasks"
          element={
            <ScreenGuard link="/commercial/crm/tasks">
              <Tasks />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/commercial/crm/estimates"
          element={
            <ScreenGuard link="/commercial/crm/estimates">
              <Estimates />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/gestao"
          element={<Navigate to="/gestao/painel" replace />}
        ></Route>
        <Route
          path="/gestao/painel"
          element={
            <ScreenGuard link="/gestao/painel">
              <GestaoPainel />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/gestao/funil"
          element={
            <ScreenGuard link="/gestao/funil">
              <GestaoFunil />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/gestao/operacoes"
          element={
            <ScreenGuard link="/gestao/operacoes">
              <GestaoOperacoes />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/gestao/cambio"
          element={
            <ScreenGuard link="/gestao/cambio">
              <GestaoCambio />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/gestao/swifts"
          element={
            <ScreenGuard link="/gestao/swifts">
              <GestaoSwifts />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/gestao/comercial"
          element={
            <ScreenGuard link="/gestao/comercial">
              <GestaoComercial />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/gestao/distribuidora"
          element={
            <ScreenGuard link="/gestao/distribuidora">
              <GestaoDistribuidora />
            </ScreenGuard>
          }
        ></Route>
        <Route path="/crm" element={<Navigate to="/commercial/crm/leads" replace />} />
        <Route path="/crm/dashboard" element={<Navigate to="/commercial/crm/dashboard" replace />} />
        <Route path="/crm/leads" element={<Navigate to="/commercial/crm/leads" replace />} />
        <Route path="/crm/tasks" element={<Navigate to="/commercial/crm/tasks" replace />} />
        <Route path="/crm/estimates" element={<Navigate to="/commercial/crm/estimates" replace />} />
        <Route
          path="/savePurchaseOrders"
          element={
            <ScreenGuard link="/purchaseOrders">
              <SavePurchaseOrder />
            </ScreenGuard>
          }
        ></Route>
        <Route
          path="/report"
          element={
            <ScreenGuard link="/report">
              <Report />
            </ScreenGuard>
          }
        ></Route>
      </Routes>
    </Box>
  );
}

export default App;
